var render = function render(){var _vm=this,_c=_vm._self._c;return _c('maintenance-page',{attrs:{"page-title":"Lease","page-icon":"mdi-file-document-outline","collection-name":"lease","done-redirect-url":"/auth/admin/lease?isHistory=true","buttons-left-items":_vm.buttons,"button-functions":{ propertyAreaRedirect: _vm.propertyAreaRedirect }}})
}
var staticRenderFns = []

export { render, staticRenderFns }